// API configuration
export const API_URL = process.env.REACT_APP_API_URL === '/api'
  ? '' // Empty string = relative path (production)
  : process.env.REACT_APP_API_URL 
    ? process.env.REACT_APP_API_URL.replace(/\/api$/, '') // Remove trailing /api if present
    : 'http://localhost:8001'; // Default for local development
